import { createContext, useReducer, useContext } from 'react';
import { useAvailableConsults } from "@iscr/xAppLib/Hooks/useAvailableConsults";

const INITIAL_STATE = {
  selectedDiscount: {},
};
const discountReducer = (state, action) => {
  switch (action.type) {
    case "UPDATE_DISCOUNT_ITEM":
      return {
        ...state,
        selectedDiscount: {
          ...state.selectedDiscount,
          [action.payload.fieldKey]: action.payload.value,
        },
      };
    case "SET_SELECTED_DISCOUNT":
      return {
        ...state,
        selectedDiscount: action.payload,
      };
    default:
      return state;
  }
};

const DiscountContext = createContext(undefined);
// Provider Component
export const DiscountsProvider = ({ children }) => {
  const [state, dispatch] = useReducer(discountReducer, INITIAL_STATE);
  const { availableConsults = [] } = useAvailableConsults();

  const value = { state: { ...state, availableConsults }, dispatch };

  return (
    <DiscountContext.Provider value={value}>
      {children}
    </DiscountContext.Provider>
  );
};

export const useDiscountsContext = () => {
  const context = useContext(DiscountContext);
  if (!context) {
    throw new Error("useDiscountContext must be used within a Provider");
  }

  return context;
};
